// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonContainer {
    background-color: #1A1A1A;
    width: 200px;
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;
    border: 2px solid #00FFFF;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.1);
}

.buttonContainer:hover {
    transform: translateY(-5px);
    box-shadow: 0 0 25px rgba(0, 255, 255, 0.2);
}

.buttonContainer.disabled {
    cursor: not-allowed;
    filter: grayscale(100%);
    opacity: 0.7;
}

.buttonContainer.disabled:hover {
    transform: none;
}

.buttonContainer.disabled .lock-overlay {
    filter: none; /* Keep the lock icon colorful */
}

.buttonContainer img.mode-icon {
    width: auto;
    height: auto;
    max-width: 80px;
    margin-top: -48px;
    padding: 8px;
}

.buttonContainer.ranked img.mode-icon {
    margin-top: -90px;
}

.labelContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    width: 100%;
}

.buttonContainer.ranked .labelContainer {
    margin-top: -5px;
}

.buttonContainer[data-playmode="practice"] .labelContainer {
    margin-top: 15px;
}

.buttonContainer[data-playmode="casual"] .labelContainer {
    margin-top: 10px;
}

.labelContainer .label {
    font-size: 24px;
    font-weight: 700;
    color: #FFFFFF;
    text-transform: uppercase;
    font-family: "Kim";
    margin-bottom: 16px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    letter-spacing: 2px;
}

.buttonContainer.ranked .labelContainer .label {
    color: #FFB000;
}

.labelContainer .player {
    font-size: 14px;
    color: #4ff4f6;
    margin-bottom: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.labelContainer .player .count {
    color: #FFB653;
}

.info-container {
    width: 100%;
    margin-top: 16px;
    background: rgba(0, 0, 0, 0.2);
    padding: 12px;
    border-radius: 4px;
}

.buttonContainer.disabled .info-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
    padding: 4px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    color: #999999;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.info-label .reward-icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
}

.info-value {
    color: #FFFFFF;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.info-value.high {
    color: #00FF66;
    text-shadow: 0 0 8px rgba(0, 255, 102, 0.3);
}

.info-value.medium {
    color: #FFE666;
    text-shadow: 0 0 8px rgba(255, 230, 102, 0.3);
}

.info-value.low {
    color: #FF9966;
    text-shadow: 0 0 8px rgba(255, 153, 102, 0.3);
}

.playModeButton.disabled {
    cursor: not-allowed;
    pointer-events: all;
}

.playModeButton.disabled:hover {
    transform: none;
}

.playModeButton img.grayscale {
    filter: grayscale(100%);
}

.playModeButton .lock-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 48px;
    height: 48px;
    pointer-events: none;
}

.buttonContainer.ranked {
    border-color: #FFB000;
    box-shadow: 0 0 15px rgba(255, 176, 0, 0.1);
}

.buttonContainer.ranked:hover {
    box-shadow: 0 0 25px rgba(255, 176, 0, 0.2);
}

.lock-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 8px 0 0 0;
    flex-direction: column;
    gap: 16px;
}

.lock-container .lock-icon {
    width: 64px;
    height: 64px;
    pointer-events: none;
}

.lock-container .unlock-message {
    color: #FFB653;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: -8px;
}`, "",{"version":3,"sources":["webpack://./src/components/playModeButton/playModeButton.style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY,EAAE,gCAAgC;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB","sourcesContent":[".buttonContainer {\n    background-color: #1A1A1A;\n    width: 200px;\n    height: 280px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    cursor: pointer;\n    border: 2px solid #00FFFF;\n    border-radius: 8px;\n    padding: 16px;\n    transition: all 0.3s ease;\n    box-shadow: 0 0 15px rgba(0, 255, 255, 0.1);\n}\n\n.buttonContainer:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 0 25px rgba(0, 255, 255, 0.2);\n}\n\n.buttonContainer.disabled {\n    cursor: not-allowed;\n    filter: grayscale(100%);\n    opacity: 0.7;\n}\n\n.buttonContainer.disabled:hover {\n    transform: none;\n}\n\n.buttonContainer.disabled .lock-overlay {\n    filter: none; /* Keep the lock icon colorful */\n}\n\n.buttonContainer img.mode-icon {\n    width: auto;\n    height: auto;\n    max-width: 80px;\n    margin-top: -48px;\n    padding: 8px;\n}\n\n.buttonContainer.ranked img.mode-icon {\n    margin-top: -90px;\n}\n\n.labelContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 0px;\n    width: 100%;\n}\n\n.buttonContainer.ranked .labelContainer {\n    margin-top: -5px;\n}\n\n.buttonContainer[data-playmode=\"practice\"] .labelContainer {\n    margin-top: 15px;\n}\n\n.buttonContainer[data-playmode=\"casual\"] .labelContainer {\n    margin-top: 10px;\n}\n\n.labelContainer .label {\n    font-size: 24px;\n    font-weight: 700;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    font-family: \"Kim\";\n    margin-bottom: 16px;\n    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);\n    letter-spacing: 2px;\n}\n\n.buttonContainer.ranked .labelContainer .label {\n    color: #FFB000;\n}\n\n.labelContainer .player {\n    font-size: 14px;\n    color: #4ff4f6;\n    margin-bottom: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.labelContainer .player .count {\n    color: #FFB653;\n}\n\n.info-container {\n    width: 100%;\n    margin-top: 16px;\n    background: rgba(0, 0, 0, 0.2);\n    padding: 12px;\n    border-radius: 4px;\n}\n\n.buttonContainer.disabled .info-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n    font-size: 14px;\n    padding: 4px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.info-row:last-child {\n    border-bottom: none;\n}\n\n.info-label {\n    color: #999999;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.info-label .reward-icon {\n    width: 16px;\n    height: 16px;\n    object-fit: contain;\n}\n\n.info-value {\n    color: #FFFFFF;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n.info-value.high {\n    color: #00FF66;\n    text-shadow: 0 0 8px rgba(0, 255, 102, 0.3);\n}\n\n.info-value.medium {\n    color: #FFE666;\n    text-shadow: 0 0 8px rgba(255, 230, 102, 0.3);\n}\n\n.info-value.low {\n    color: #FF9966;\n    text-shadow: 0 0 8px rgba(255, 153, 102, 0.3);\n}\n\n.playModeButton.disabled {\n    cursor: not-allowed;\n    pointer-events: all;\n}\n\n.playModeButton.disabled:hover {\n    transform: none;\n}\n\n.playModeButton img.grayscale {\n    filter: grayscale(100%);\n}\n\n.playModeButton .lock-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 48px;\n    height: 48px;\n    pointer-events: none;\n}\n\n.buttonContainer.ranked {\n    border-color: #FFB000;\n    box-shadow: 0 0 15px rgba(255, 176, 0, 0.1);\n}\n\n.buttonContainer.ranked:hover {\n    box-shadow: 0 0 25px rgba(255, 176, 0, 0.2);\n}\n\n.lock-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 8px 0 0 0;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.lock-container .lock-icon {\n    width: 64px;\n    height: 64px;\n    pointer-events: none;\n}\n\n.lock-container .unlock-message {\n    color: #FFB653;\n    font-size: 14px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-top: -8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
